/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React from "react";
import { useDropzone } from "react-dropzone";
import { DragNDropArea } from "./DragNDropArea";
export var DragNDrop = function (props) {
    var onDrop = React.useCallback(function (acceptedFiles) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        acceptedFiles.forEach(function (file) {
            var reader = new FileReader();
            reader.onabort = function () { return console.log("Claude: file reading was aborted"); };
            reader.onerror = function () { return console.log("Claude: file reading has failed"); };
            reader.onload = function () {
                props.onReceivedFile(file);
            };
            reader.readAsArrayBuffer(file);
        });
    }, [props]);
    var _a = useDropzone({ onDrop: onDrop }), getRootProps = _a.getRootProps, getInputProps = _a.getInputProps;
    return (React.createElement(DragNDropArea, { wrapper: getRootProps, input: getInputProps }));
};
